import PERMISSION from "./permissions";

const screenPermissions = [
  {
    title: "Tài khoản quản trị",
    key: "UserSystem",
    disabled: false,
    children: [
      {
        title: "Hiển thị tài khoản",
        key: PERMISSION.Admin_UserSystem_View,
      },
      {
        title: "Thêm tài khoản",
        key: PERMISSION.Admin_UserSystem_Create,
      },
      {
        title: "Sửa tài khoản",
        key: PERMISSION.Admin_UserSystem_Update,
      },
      {
        title: "Xóa tài khoản",
        key: PERMISSION.Admin_UserSystem_Delete,
      },
      {
        title: "Reset mật khẩu tài khoản",
        key: PERMISSION.Admin_UserSystem_ResetPassword,
      },
    ],
  },
  {
    title: "Phân quyền",
    key: "Role",
    disabled: false,
    children: [
      {
        title: "Hiển thị quyền",
        key: PERMISSION.Admin_Role_View,
      },
      {
        title: "Thêm quyền",
        key: PERMISSION.Admin_Role_Create,
      },
      {
        title: "Sửa quyền",
        key: PERMISSION.Admin_Role_Update,
      },
      {
        title: "Xóa quyền",
        key: PERMISSION.Admin_Role_Delete,
      },
    ],
  },
  {
    title: "Tài khoản khách hàng",
    key: "UserCustomer",
    disabled: false,
    children: [
      {
        title: "Hiển thị tài khoản",
        key: PERMISSION.Admin_UserCustomer_View,
      },
      {
        title: "Thêm tài khoản",
        key: PERMISSION.Admin_UserCustomer_Create,
      },
      {
        title: "Sửa tài khoản",
        key: PERMISSION.Admin_UserCustomer_Update,
      },
      {
        title: "Xóa tài khoản",
        key: PERMISSION.Admin_UserCustomer_Delete,
      },
    ],
  },
  {
    title: "Đơn hàng",
    key: "Order",
    disabled: false,
    children: [
      {
        title: "Chi tiết",
        key: PERMISSION.Admin_Order_View,
      },
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Order_Get,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Order_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Order_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Order_Delete,
      },
    ],
  },
  {
    title: "Sản phẩm",
    key: "Product",
    disabled: false,
    children: [
      {
        title: "Hiển thị sản phẩm",
        key: PERMISSION.Admin_Product_View,
      },
      {
        title: "Thêm sản phẩm",
        key: PERMISSION.Admin_Product_Create,
      },
      {
        title: "Sửa sản phẩm",
        key: PERMISSION.Admin_Product_Update,
      },
      {
        title: "Xóa sản phẩm",
        key: PERMISSION.Admin_Product_Delete,
      },
    ],
  },
  {
    title: "Danh mục sản phẩm",
    key: "ProductCategory",
    disabled: false,
    children: [
      {
        title: "Hiển thị danh mục",
        key: PERMISSION.Admin_ProductCategory_View,
      },
      {
        title: "Thêm danh mục",
        key: PERMISSION.Admin_ProductCategory_Create,
      },
      {
        title: "Sửa danh mục",
        key: PERMISSION.Admin_ProductCategory_Update,
      },
      {
        title: "Xóa danh mục",
        key: PERMISSION.Admin_ProductCategory_Delete,
      },
    ],
  },
  {
    title: "Bài viết",
    key: "Blog",
    disabled: false,
    children: [
      {
        title: "Hiển thị bài viết",
        key: PERMISSION.Admin_Blog_View,
      },
      {
        title: "Thêm bài viết",
        key: PERMISSION.Admin_Blog_Create,
      },
      {
        title: "Sửa bài viết",
        key: PERMISSION.Admin_Blog_Update,
      },
      {
        title: "Xóa bài viết",
        key: PERMISSION.Admin_Blog_Delete,
      },
    ],
  },
  {
    title: "Chuyên mục bài viết",
    key: "BlogCategory",
    disabled: false,
    children: [
      {
        title: "Hiển thị chuyên mục",
        key: PERMISSION.Admin_BlogCategory_View,
      },
      {
        title: "Thêm chuyên mục",
        key: PERMISSION.Admin_BlogCategory_Create,
      },
      {
        title: "Sửa chuyên mục",
        key: PERMISSION.Admin_BlogCategory_Update,
      },
      {
        title: "Xóa chuyên mục",
        key: PERMISSION.Admin_BlogCategory_Delete,
      },
    ],
  },
  {
    title: "Mã giảm giá",
    key: "Voucher",
    disabled: false,
    children: [
      {
        title: "Hiển thị mã giảm giá",
        key: PERMISSION.Admin_Voucher_View,
      },
      {
        title: "Thêm mã giảm giá",
        key: PERMISSION.Admin_Voucher_Create,
      },
      {
        title: "Sửa mã giảm giá",
        key: PERMISSION.Admin_Voucher_Update,
      },
      {
        title: "Xóa mã giảm giá",
        key: PERMISSION.Admin_Voucher_Delete,
      },
    ],
  },
  {
    title: "Khuyến mãi",
    key: "Promotion",
    disabled: false,
    children: [
      {
        title: "Hiển thị khuyến mãi",
        key: PERMISSION.Admin_Promotion_View,
      },
      {
        title: "Thêm mã khuyến mãi",
        key: PERMISSION.Admin_Promotion_Create,
      },
      {
        title: "Sửa mã khuyến mãi",
        key: PERMISSION.Admin_Promotion_Update,
      },
      {
        title: "Xóa mã khuyến mãi",
        key: PERMISSION.Admin_Promotion_Delete,
      },
    ],
  },
  {
    title: "Hệ thống",
    key: "Setting",
    disabled: false,
    children: [
      {
        title: "Hiển thị cài đặt",
        key: PERMISSION.Admin_Setting_View,
      },
      {
        title: "Thêm cài đặt",
        key: PERMISSION.Admin_Setting_Create,
      },
      {
        title: "Sửa cài đặt",
        key: PERMISSION.Admin_Setting_Update,
      },
      {
        title: "Xóa cài đặt",
        key: PERMISSION.Admin_Setting_Delete,
      },
    ],
  },
  {
    title: "Báo cáo",
    key: "Report",
    disabled: false,
    children: [
      {
        title: "Hiển thị báo cáo",
        key: PERMISSION.Admin_Report_View,
      },
      {
        title: "Thêm báo cáo",
        key: PERMISSION.Admin_Report_Create,
      },
      {
        title: "Sửa báo cáo",
        key: PERMISSION.Admin_Report_Update,
      },
      {
        title: "Xóa báo cáo",
        key: PERMISSION.Admin_Report_Delete,
      },
      {
        title: "Xuất báo cáo",
        key: PERMISSION.Admin_Report_Export,
      },
    ],
  },
  {
    title: "Vận chuyển",
    key: "Shipping",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Shipping_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Shipping_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Shipping_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Shipping_Delete,
      },
      {
        title: "Sửa ghi chú",
        key: PERMISSION.Admin_Shipping_Note_Create,
      },
      {
        title: "Xóa ghi chú",
        key: PERMISSION.Admin_Shipping_Note_Delete,
      },
    ],
  },
  {
    title: "Địa chỉ lấy hàng",
    key: "address",
    disabled: true,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Address_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Address_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Address_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Address_Delete,
      },
    ],
  },
  {
    title: "Phương thức thanh toán",
    key: "Payments",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Payment_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Payment_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Payment_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Payment_Delete,
      },
    ],
  },
  {
    title: "Trang động",
    key: "page",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Page_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Page_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Page_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Page_Delete,
      },
    ],
  },
  {
    title: "Báo chí",
    key: "newPapers",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Newspapers_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Newspapers_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Newspapers_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Newspapers_Delete,
      },
    ],
  },
  {
    title: "Đánh giá",
    key: "reviews",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Review_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Review_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Review_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Review_Delete,
      },
    ],
  },
  {
    title: "Chương trình quảng cáo",
    key: "advertising",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Advertising_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Advertising_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Advertising_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Advertising_Delete,
      },
    ],
  },
  {
    title: "Menu",
    key: "menu",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Menu_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Menu_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Menu_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Menu_Delete,
      },
    ],
  },
  {
    title: "Đại lý",
    key: "dealer",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Agency_View,
      },
      {
        title: "Thêm mới",
        key: PERMISSION.Admin_Agency_Create,
      },
      {
        title: "Sửa",
        key: PERMISSION.Admin_Agency_Update,
      },
      {
        title: "Xóa",
        key: PERMISSION.Admin_Agency_Delete,
      },
    ],
  },
  {
    title: "Hệ thống Logs",
    key: "transaction",
    disabled: false,
    children: [
      {
        title: "Hiển thị",
        key: PERMISSION.Admin_Transaction_View,
      },
    ],
  },
];

export default screenPermissions;
